<template>
  <div id="totalBox">
    <div class="bannerBox">
      <div class="bannerTitle">成功案例</div>
      <div class="line"></div>
      <div class="bannercontent">我们已有多个成功案例，遍布杭州、绍兴、湖州、嘉兴、淄博、德州、西安、甘肃等多个城市。</div>
      <div class="bannercontent">涉及医院，园区，商超，酒店、小区，公共停车场等多个行业，依据行业特性定制专有的管理模式。</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ckbanner',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  height: 500px;
  background-color: RGBA(12, 137, 24, 1);
}
.bannerBox{
  width: 1200px;
  height: 500px;
  margin: 0 auto;
  padding-top: 60px;
  text-align: left;
}
.bannerTitle{
  font-size:30px;
  font-weight:bold;
  color:rgba(255,255,255,1);
  line-height:30px;
}
.line{
  width:30px;
  height:4px;
  background:rgba(255,182,30,1);
  margin-top: 11px;
  margin-bottom: 20px;
}
.bannercontent{
  font-size:18px;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:30px;
}
</style>



// WEBPACK FOOTER //
// src/components/example/exampleBanner.vue